// extracted by mini-css-extract-plugin
module.exports = {"textContainer":"TextBlock_textContainer__AKWOe","fullWidth":"TextBlock_fullWidth__0TW6U"};